<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="frontmatter">
<div epub:type="frontmatter">
<section epub:type="division">
<h1 class="toc_title"><strong>CONTENTS</strong></h1>
<p class="toc_fm"><a href="#/Text/9781454925767_epub_itr_r1">INTRODUCTION: ALL THAT GLITTERS</a></p>
<div class="part">
<p class="toc_part"><a href="#/Text/9781454925767_epub_p01_r1"><strong>PART I: PEOPLE AND THINGS</strong></a></p>
<div class="toc_img"><img alt="" src="Images/v.jpg"/></div>
<p class="toc_chapter"><a href="#/Text/9781454925767_epub_c01_r1"><span class="toc_small"><strong>CHAPTER 1</strong></span><br/>Centennial</a></p>
<p class="toc_chapter"><span href="#/Text/9781454925767_epub_c02_r1" title="Link target outside of Sample"><span class="toc_small"><strong>CHAPTER 2</strong></span><br/>The Dynamo, the Virgin, and the Bridge</span></p>
<p class="toc_chapter"><span href="#/Text/9781454925767_epub_c03_r1" title="Link target outside of Sample"><span class="toc_small"><strong>CHAPTER 3</strong></span><br/>Titans, Plutocrats, and Philanthropists</span></p>
<p class="toc_chapter"><span href="#/Text/9781454925767_epub_c04_r1" title="Link target outside of Sample"><span class="toc_small"><strong>CHAPTER 4</strong></span><br/>Science and Industry</span></p>
<p class="toc_chapter"><span href="#/Text/9781454925767_epub_c05_r1" title="Link target outside of Sample"><span class="toc_small"><strong>CHAPTER 5</strong></span><br/>The Marketplace</span></p>
<p class="toc_chapter"><span href="#/Text/9781454925767_epub_c06_r1" title="Link target outside of Sample"><span class="toc_small"><strong>CHAPTER 6</strong></span><br/>Statue and Island</span></p>
<p class="toc_chapter"><span href="#/Text/9781454925767_epub_c07_r1" title="Link target outside of Sample"><span class="toc_small"><strong>CHAPTER 7</strong></span><br/>Hard Labor</span></p>
<p class="toc_chapter"><span href="#/Text/9781454925767_epub_c08_r1" title="Link target outside of Sample"><span class="toc_small"><strong>CHAPTER 8</strong></span><br/>Gilded Monuments</span></p>
<p class="toc_chapter"><span href="#/Text/9781454925767_epub_c09_r1" title="Link target outside of Sample"><span class="toc_small"><strong>CHAPTER 9</strong></span><br/>American Realism</span></p>
</div>
<div class="part">
<p class="toc_part"><span href="#/Text/9781454925767_epub_p02_r1" title="Link target outside of Sample"><strong>PART II: FORM AND REFORM</strong></span></p>
<div class="toc_img"><img alt="" src="Images/v.jpg"/></div>
<p class="toc_chapter"><span href="#/Text/9781454925767_epub_c10_r1" title="Link target outside of Sample"><span class="toc_small"><strong>CHAPTER 10</strong></span><br/>Reconstruction Ends</span></p>
<p class="toc_chapter"><span href="#/Text/9781454925767_epub_c11_r1" title="Link target outside of Sample"><span class="toc_small"><strong>CHAPTER 11</strong></span><br/>A Woman’s Place</span></p>
<p class="toc_chapter"><span href="#/Text/9781454925767_epub_c12_r1" title="Link target outside of Sample"><span class="toc_small"><strong>CHAPTER 12</strong></span><br/>The Frontier Closes</span></p>
<p class="toc_chapter"><span href="#/Text/9781454925767_epub_c13_r1" title="Link target outside of Sample"><span class="toc_small"><strong>CHAPTER 13</strong></span><br/>Dirty Politics</span></p>
<p class="toc_chapter"><span href="#/Text/9781454925767_epub_c14_r1" title="Link target outside of Sample"><span class="toc_small"><strong>CHAPTER 14</strong></span><br/>The Progressives</span></p>
<p class="toc_chapter"><span href="#/Text/9781454925767_epub_c15_r1" title="Link target outside of Sample"><span class="toc_small"><strong>CHAPTER 15</strong></span><br/>White City</span></p>
</div>
<div class="toc_bm">
<p class="toc_bm"><span href="#/Text/9781454925767_epub_ack_r1" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></p>
<p class="toc_bm"><span href="#/Text/9781454925767_epub_nts_r1" title="Link target outside of Sample">SOURCE NOTES</span></p>
<p class="toc_bm"><span href="#/Text/9781454925767_epub_bib_r1" title="Link target outside of Sample">FURTHER READING</span></p>
<p class="toc_bm"><span href="#/Text/9781454925767_epub_cre_r1" title="Link target outside of Sample">IMAGE CREDITS</span></p>
</div>
</section>
</div>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781454925767_epub_toc_r1.vue?7758c6e7